export const MAX_FILES_PER_INVENTORY_ITEM = 2;

export const MAX_FILES_PER_INVENTORY_ITEM_ERROR =
  'Error - A maximum of 2 files per damaged/stolen item can be uploaded.';

/** Fails when 3 or more files are selected (limit is 2). */
export const getInventoryEvidenceFileLimitError = (
  hasDamageEvidence: string,
  files: FileList | null | undefined
): string | null => {
  if (hasDamageEvidence !== 'yes') {
    return null;
  }
  const count = files?.length ?? 0;
  if (count >= MAX_FILES_PER_INVENTORY_ITEM + 1) {
    return MAX_FILES_PER_INVENTORY_ITEM_ERROR;
  }
  return null;
};

export const inventoryEvidenceFilesAreValid = (
  hasDamageEvidence: string,
  files: FileList | null | undefined
): boolean => getInventoryEvidenceFileLimitError(hasDamageEvidence, files) === null;
